export default {"src":"/_next/static/media/locationPinIcon.2a7b8f16.svg","height":16,"width":12};